export default {"src":"/_next/static/media/FCTLogoLight.93662dbf.gif","height":88,"width":306,"blurWidth":0,"blurHeight":0};